module.exports = ".public-dataset-details {\n  margin-top: 0px !important; }\n\n.info p {\n  margin: 0; }\n\n.inner-text p {\n  margin: 0 !important; }\n"